<template>
    <div style="margin-top: 15px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/serviceSheet' }">服务工单</el-breadcrumb-item>
            <el-breadcrumb-item><span style="color: dodgerblue">工单详情</span></el-breadcrumb-item>
        </el-breadcrumb>


        <div align="left" style="margin-top: 20px; height: 40px">
            <span style="  border-radius: 4px; color: white; background-color: dodgerblue; padding: 5px; ">{{obj.account_name}}</span>
            <span style=" margin-left: 5px; color: dodgerblue; padding: 5px; ">{{obj.store_name}}</span>
        </div>


        <el-row :gutter="24">
            <el-col :span="12">
                <div align="left">
                    <span style=" color: orange; padding: 5px; font-size: 12px">服务单号</span>
                    <span style=" color: slategrey; padding: 5px;  font-size: 12px">{{obj.ticket_no}}</span>
                </div>
                <div align="left" style="margin-top: 10px">
                    <span style=" color: orange; padding: 5px;  font-size: 12px">服务人员</span>
                    <span style=" color: slategrey; padding: 5px;  font-size: 12px">{{obj.alias + ' ' + obj.phone}}</span>
                </div>
            </el-col>

            <el-col :span="12">
                <div align="right">
                    <el-row>
                        <!--<el-button size="mini" type="primary" @click.stop="saveFifth">保存</el-button>-->
                        <el-button size="mini" type="danger" @click.stop="backFifthForm">
                            <img :src="backArrow" width="12px" style="margin-right: 5px;">返回
                        </el-button>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <div style="width: 100%; height: 0px; margin-top: 10px;border:1px dashed gainsboro"></div>
        <el-form :model="form" label-width="12%">

            <div align="center" style="margin-top: 40px">
                <span style=" margin-left: 5px; color: dodgerblue; padding: 5px; ">{{form.tenant_name}}</span>
            </div>

            <el-row :gutter="24" style="margin-top: 10px">

                <el-col :span="12">

                    <div align="left" style="margin-left: 30px">
                        <span style=" color: gainsboro; font-size: 14px">制单人：</span>
                        <span style=" color: gainsboro; font-size: 14px">{{form.create_name}}</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div align="right">
                        <div align="right">
                            <span style=" color: gainsboro; padding: 5px;  font-size: 14px">日期：</span>
                            <span style=" color: gainsboro; padding: 5px;  font-size: 14px">{{form.date}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-form-item label="报价单名称" style="margin-top: 20px">
                <el-input placeholder="请输入内容" v-model="form.quotation_name" disabled clearable></el-input>
            </el-form-item>

            <el-form-item label="报价有效日期" style="margin-top: 20px">
                <div class="block">
                    <!--<el-date-picker-->
                    <!--v-model="formInfo.effective_date"-->
                    <!--type="date"-->
                    <!--placeholder="选择日期">-->
                    <!--</el-date-picker>-->


                    <el-date-picker disabled
                                    v-model="form.effective_date"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>


                </div>

            </el-form-item>


            <el-row :gutter="24" style="margin-top: 10px">
                <el-col :span="12">
                    <div align="left" style="margin-left: 20px">
                        <span style=" color: gainsboro; padding: 5px; font-size: 14px">收费项目</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div align="right">

                    </div>
                </el-col>
            </el-row>

            <el-table
                    :data="form.tableData"
                    style="width: 100%; margin-left: 10px; margin-right: 10px;">

                <el-table-column label="">
                    <template slot-scope="scope">

                        <el-row :gutter="24">
                            <el-col :span="6">
                                <div align="left">
                                    <el-row>
                                        <span>{{scope.row.quotation_item}}</span>
                                    </el-row>
                                </div>
                            </el-col>
                            <el-col :span="18">
                                <div align="right">
                                    <el-row>
                                        <span style="color: lightgray">说明：</span>
                                        <span style="color: dodgerblue">{{scope.row.quotation_comments}}</span>
                                        <span style="color: lightgray; margin-left: 10px">|  数量：</span>
                                        <span style="color: orange">{{scope.row.quotation_number}}</span>
                                        <span style="color: lightgray; margin-left: 10px">|  金额：</span>
                                        <span style="color: orange">{{scope.row.quotation_amount}}</span>
                                        <el-button type="warning" size="small" style="left: 10px"
                                                   @click.stop="showFifthItemInfo(scope.$index, scope.row)">
                                            详情
                                        </el-button>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
            <!--<el-button style="margin-left: 10px; margin-top: 10px; color: orange"-->
            <!--type="text" icon="el-icon-plus" @click="addFifthItem">-->
            <!--<span style="color: orange">添加更多的收费项目</span>-->
            <!--</el-button>-->

            <el-row :gutter="24" style="margin-top: 10px; margin-bottom: 40px">

                <el-col :span="12">
                    <div align="left" style="margin-left: 20px">
                        <span style=" color: dodgerblue; padding: 5px; font-size: 14px">合计金额：</span>
                    </div>

                </el-col>
                <el-col :span="12">
                    <div align="right">
                        <div align="right">
                            <span style=" color: dodgerblue; padding: 5px;  font-size: 14px">{{form.sumamount}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>


        <el-dialog
                :visible.sync="form4.info"
                width="750px"
                height="75%"
                :show-close="false"
                :before-close="handleClose"
                class="a_modal"
                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -30px; ">

                <el-row>
                    <el-col :span="12">
                        <span style="color: cornflowerblue; font-size: 18px">收费项目</span>
                    </el-col>
                    <el-col :span="12">
                        <div align="right" style="margin-top: -5px">
                            <el-row>
                                <!--<el-button type="success" size="small"-->
                                           <!--@click.stop="saveForm4Info">确定-->
                                <!--</el-button>-->
                                <el-button type="danger" size="small"
                                           @click.stop="form4.info=false">取消
                                </el-button>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <div style="width: 100%; height: 0px; margin-top: 15px;border:1px dashed gainsboro"></div>

                <div style="margin-top: 20px">
                    <el-form ref="form4" :model="form4" label-width="10%">
                        <el-form-item label="项目">
                            <el-input placeholder="请输入项目名称" v-model="form4.quotation_item" disabled
                                      clearable></el-input>

                        </el-form-item>
                        <el-form-item label="数量">
                            <el-input type="number" placeholder="请输入数量" v-model="form4.quotation_number" disabled
                                      clearable></el-input>

                        </el-form-item>


                        <el-form-item label="金额">
                            <el-input type="number" placeholder="请输入金额" v-model="form4.quotation_amount" disabled
                                      clearable></el-input>

                        </el-form-item>

                        <el-form-item label="说明">
                            <el-input disabled
                                    type="textarea"
                                    :autosize="{ minRows: 4, maxRows: 10}"
                                    placeholder="请输入说明内容"
                                    v-model="form4.quotation_comments">
                            </el-input>
                        </el-form-item>
                    </el-form>

                </div>

            </div>

        </el-dialog>


    </div>
</template>

<script>
    import http from '../../../APIService/http'
    import backArrow from '../../../assets/images/back-arrow.png'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//                }
//            },
//            obj: {
//                type: Object,
//                default: () => {
//                }
//
//            }
        },
        components: {},
        data() {
            return {
                backArrow: backArrow,
                form: {
                    quotation_status: '',
                    created_by: '',
                    created_date: '',
                    quotation_id: '',
                    effective_date: '',
                    sumamount: '',
                    tenant_name: '',
                    create_name: '',
                    info: false,
                    title: '',
                    date: '',
                    tableData: []
                },
                form4: {
                    quotation_name: '',
                    quotation_number: '',
                    quotation_amount: '',
                    quotation_item: '',
                    info: false,

                },
                obj: {
//                    initiator: "RETAIL"
                    initiator: "SERVICE",
                    created_by: "",
                    account_name: "",
                    store_name: "",
                    alias: "",
                    ticket_id: '',
                    ticket_no: "",
                    phone: "",
                    photo: [],
                    status: "NEW",
                    stepDatas: [{title: "已接单"},
                        {title: "已派单"},
                        {title: "进行中"},
                        {title: "已完工"},
                        {title: "已评价"}],
                },
            }
        },
        computed: {},
        created() {

        },
        methods: {
            setInfo(data) {
                this.form.quotation_name = data.quotation_name
                this.form.effective_date = data.effective_date
                this.form.tableData = data.item
                this.form.sumamount = data.sumamount

                this.form.quotation_status = data.status
                this.form.quotation_id = data.quotation_id
                this.form.created_date = data.created_date
                this.form.created_by = data.created_by
            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            addFifthItem(index, row) {

                this.form4.quotation_comments = ""
                this.form4.quotation_number = ""
                this.form4.quotation_amount = ""
                this.form4.quotation_item = ""
                this.form4.info = true

            },
            getObj(data) {

                this.obj = data
            },

            backFifthForm() {
                this.$emit('backFifthForm')
            },
            async saveFifth() {


                this.loading = true
                var user = this.$store.getters.getUser
                try {

                    var quotation_id = ''
                    var created_by = user.user_id
                    var created_date = new Date().Format('yyyy-MM-dd')
                    var type = 'ADD'
                    if (this.formInfo.quotation_id != '') {
                        created_by = this.formInfo.created_by
                        type = 'EDIT'
                        created_date = this.formInfo.created_date
                        quotation_id = this.formInfo.quotation_id
                    }


                    var paramStr = "client_id=" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"effective_date\":\"" + new Date(this.formInfo.effective_date).Format('yyyy-MM-dd') + "\","
                        + "\"sumamount\":\"" + this.formInfo.sumamount + "\","
                        + "\"quotation_status\":\"" + this.formInfo.quotation_status + "\","
                        + "\"quotation_name\":\"" + this.formInfo.quotation_name + "\","
                        + "\"quotation_id\":\"" + quotation_id + "\","
                        + "\"ticket_id\":\"" + this.obj.ticket_id + "\","
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"user_id\":\"" + user.user_id + "\","
                        + "\"created_by\":\"" + created_by + "\","
                        + "\"modified_by\":\"" + user.user_id + "\","
                        + "\"created_date\":\"" + created_date + "\","
                        + "\"type\":\"" + type + "\","
                        + "\"submit\":\"" + "" + "\", "
                        + "\"item\":[";


                    if (this.formInfo.tableData.length > 0) {
                        for (var i = 0; i < this.formInfo.tableData.length; i++) {
                            var dic = this.formInfo.tableData[i]
                            if (i == 0) {
                                paramStr = paramStr + " {\"quotation_comments\": \"" + dic.quotation_comments + "\", " +
                                    "\"quotation_number\" : \"" + dic.quotation_number + "\", " +
                                    "\"quotation_amount\" : \"" + dic.quotation_amount + "\", " +
                                    "\"quotation_item\":\"" + dic.quotation_item + "\"} ";
                            } else {
                                paramStr = paramStr + ", {\"quotation_comments\": \"" + dic.quotation_comments + "\", " +
                                    "\"quotation_number\" : \"" + dic.quotation_number + "\", " +
                                    "\"quotation_amount\" : \"" + dic.quotation_amount + "\", " +
                                    "\"quotation_item\":\"" + dic.quotation_item + "\"} ";
                            }
                        }
                    }
                    paramStr = paramStr + "]"

                    paramStr = paramStr + "}"


                    await http.post('https://api.concierge24x7.cn:16080/wapi/order/saveQuotation', paramStr).then(res => {


                        if (res.success) {
                            this.init(false)

                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.$emit('backFifthForm')
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },

            showFifthItemInfo(index, row) {

                this.form4.quotation_comments = row.quotation_comments
                this.form4.quotation_number = row.quotation_number
                this.form4.quotation_amount = row.quotation_amount
                this.form4.quotation_item = row.quotation_item
                this.form4.info = true


            },
        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/form/fifthInfo.vue